import {
  IconApiApp,
  IconBrandAirtable,
  IconBrandAsana,
  IconBrandIntercom,
  IconBrandNotion,
  IconBrandSlack,
  IconBrandSnowflake,
  IconBrandTrello,
  IconPlug,
  IconTableImport,
  type TablerIcon,
} from '@tabler/icons';
import ChorusIcon from './integrations/utils/icons/Chorus';
import ClickupIcon from './integrations/utils/icons/ClickupIcon';
import CodaIcon from './integrations/utils/icons/CodaIcon';
import FreshdeskIcon from './integrations/utils/icons/FreshdeskIcon';
import GainsightIcon from './integrations/utils/icons/GainsightIcon';
import GongIcon from './integrations/utils/icons/GongIcon';
import HubspotIcon from './integrations/utils/icons/HubspotIcon';
import JiminnyIcon from './integrations/utils/icons/JiminnyIcon';
import JiraIcon from './integrations/utils/icons/JiraIcon';
import LinearIcon from './integrations/utils/icons/LinearIcon';
import MomentumIcon from './integrations/utils/icons/MomentumIcon';
import PendoIcon from './integrations/utils/icons/PendoIcon';
import ProdPadIcon from './integrations/utils/icons/ProdPadIcon';
import ProductBoardIcon from './integrations/utils/icons/ProductBoardIcon';
import QualtricsIcon from './integrations/utils/icons/QualtricsIcon';
import SalesforceIcon from './integrations/utils/icons/SalesforceIcon';
import ZendeskIcon from './integrations/utils/icons/ZendeskIcon';
import ZoomInfoIcon from './integrations/utils/icons/ZoomInfoIcon';

export interface IntegrationMeta {
  label: string;
  icon: TablerIcon;
}

const META: Record<string, IntegrationMeta> = {
  airtable: { label: 'Airtable', icon: IconBrandAirtable },
  api: { label: 'API', icon: IconApiApp },
  asana: { label: 'Asana', icon: IconBrandAsana },
  chorus: { label: 'Chorus', icon: ChorusIcon },
  clickup: { label: 'ClickUp', icon: ClickupIcon },
  coda: { label: 'Coda', icon: CodaIcon },
  csv: { label: 'CSV', icon: IconTableImport },
  freshdesk: { label: 'Freshdesk', icon: FreshdeskIcon },
  gainsight: { label: 'Gainsight', icon: GainsightIcon },
  gong: { label: 'Gong', icon: GongIcon },
  hubspot: { label: 'HubSpot', icon: HubspotIcon },
  intercom: { label: 'Intercom', icon: IconBrandIntercom },
  jiminny: { label: 'Jiminny', icon: JiminnyIcon },
  jira: { label: 'Jira', icon: JiraIcon },
  linear: { label: 'Linear', icon: LinearIcon },
  momentum: { label: 'Momentum', icon: MomentumIcon },
  notion: { label: 'Notion', icon: IconBrandNotion },
  pendo: { label: 'Pendo', icon: PendoIcon },
  prodpad: { label: 'ProdPad', icon: ProdPadIcon },
  productboard: { label: 'Productboard', icon: ProductBoardIcon },
  qualtrics: { label: 'Qualtrics', icon: QualtricsIcon },
  salesforce: { label: 'Salesforce', icon: SalesforceIcon },
  slack: { label: 'Slack', icon: IconBrandSlack },
  snowflake: { label: 'Snowflake', icon: IconBrandSnowflake },
  trello: { label: 'Trello', icon: IconBrandTrello },
  zendesk: { label: 'Zendesk', icon: ZendeskIcon },
  zoominfo: { label: 'ZoomInfo', icon: ZoomInfoIcon },
};

export function getIntegrationMeta(key: string | undefined | null): IntegrationMeta {
  if (!key) return { label: 'Integration', icon: IconPlug };
  return META[key.toLowerCase()] ?? { label: key, icon: IconPlug };
}
